var map = {
	"./attack.mp3": 68842,
	"./attack.wav": 28278,
	"./boxing-bell.wav": 87579,
	"./catched.mp3": 42676,
	"./catching.mp3": 63221,
	"./choose.mp3": 49981,
	"./escaped.mp3": 88693,
	"./oldschool-1.mp3": 51175,
	"./oldschool-2.mp3": 37456,
	"./pikachu-1.mp3": 17797,
	"./pikachu-2.mp3": 27250,
	"./pikachu-3.mp3": 31767,
	"./ping.mp3": 57790,
	"./recall.mp3": 46417,
	"./telegram.mp3": 71899,
	"./yeat-bell.mp3": 83131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38239;